import React from 'react';
import heroImage from '../assets/power_tools_hero.png';

const Hero = () => {
  return (
    <section id="home" className="hero-section">
      <div className="hero-content animate-fade-in-right">
        <h1 className="hero-title">
          نمكن قطاع الصناعة بأدوات <span className="text-secondary">احترافية دقيقة</span>
        </h1>
        <p className="hero-description">
          تقدم مجموعة فيرتكس (Vertex Group) حلولاً هندسية وتعهدات مقاولات، وتوفر أحدث العدد الكهربائية وأدوات النجارة والهندسة التي تضمن لك إنجاز أعمالك بكفاءة عالية.
        </p>
        <div className="hero-actions">
          <a href="#features" className="btn-primary">اكتشف منتجاتنا</a>
          <a href="https://wa.me/963984976756" target="_blank" rel="noreferrer" className="btn-secondary">تحدث مع خبير</a>
        </div>
      </div>
      
      <div className="hero-image-wrapper animate-fade-in-left delay-200">
        <div className="hero-image-container">
          <img src={heroImage} alt="معدات كهربائية وأدوات هندسية" className="hero-image" />
          <div className="glow-effect"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
